// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

import { itemsObject } from '@automator/builder/_legacy/js/common/utilities';

/**
 * Sorts and filters actions by type
 * 
 * @param {Object} options The settings
 * @param {String} options.type The action type: instant, delayed, scheduled
 * @param {String} options.includeOnly An array with actions ID. Only those should be included
 * @param {String} options.exclude An array with actions ID. Only those should be excluded
 * @returns Array with the actions, sorted
 */
const getActions = ( { type, includeOnly, exclude } ) => {
	// Default options
	const options = {
		orderBy: 'menuOrder',
		orderByType: 'int',
		format: 'array',
		filter: {
			itemType: 'action'
		}
	}

	// If the type is not defined, invoke this function to return all actions in order
	if ( ! isDefined( type ) ) {
		return [
			...getActions( { type: 'instant', includeOnly: includeOnly, exclude: exclude } ),
			...getActions( { type: 'delayed', includeOnly: includeOnly, exclude: exclude } ),
			...getActions( { type: 'scheduled', includeOnly: includeOnly, exclude: exclude } ),
			...getActions( { type: 'delay-custom', includeOnly: includeOnly, exclude: exclude } ),
		];
	}

	// Return the different types of actions
	switch ( type ) {
		case 'instant':
			// Return only instant actions
			options.filter.isScheduled = false;
			options.filter.isDelayed = false;
			options.filter.isDelayedCustom = false;

			break;

		case 'delayed':
			// Return only delayed actions
			options.filter.isScheduled = false;
			options.filter.isDelayed = true;
			options.filter.isDelayedCustom = false;
			options.orderBy = 'delayInSeconds';

			break;

		case 'scheduled':
			// Return only scheduled actions
			options.filter.isScheduled = true;
			options.filter.isDelayed = false;
			options.filter.isDelayedCustom = false;
			options.orderBy = 'scheduleNumber';

			break;

		case 'delay-custom':
			// Return only scheduled actions
			options.filter.isScheduled = false;
			options.filter.isDelayed = false;
			options.filter.isDelayedCustom = true;

			break;
	}

	// Check if we should include only some specific actions
	if ( isDefined( includeOnly ) ) {
		options.includeOnly = includeOnly;
	} 

	// Check if we should include only some specific actions
	if ( isDefined( exclude ) ) {
		options.exclude = exclude;
	}

	return itemsObject( 'get', options );
}

export default getActions;
